import apiClient from './client';

export const IcdAgeGenderAxiosInstance = apiClient;